/* eslint-disable arrow-body-style */
import { getQueryParams } from './url';
import { base64Encode } from './string'; // UTM (Urchin Tracking Module) Google 链路追踪的格式
// 神策默认的几个渠道埋点参数

var defaultUTMProps = ['utm_medium', // 媒介名称
'utm_source', // 渠道来源
'utm_term', // 广告关键词
'utm_content', // 广告内容
'utm_campaign' // 广告名称
];
/**
 * 获取所有运营渠道参数
 * 参考 https://confluence.yijin.io/pages/viewpage.action?pageId=83620403
 * 有详细的字段说明
 */
// 智能运营使用到的字段

var utmProps = ['utm_medium', // 媒介名称
'utm_source', // 渠道来源
'utm_lang', // 语言
'utm_channel', // 渠道名称
'utm_team', // 团队名称
'utm_pmt', // 项目方团队
'utm_cet', // 活动执行方
'utm_markets', // 市场
'utm_ci', // 活动ID
'utm_csm', // 活动开始月份
'utm_csy', // 活动开始年份
'utm_cem', // 活动结束月份
'utm_cey', // 活动结束年份
'utm_cpt', // 内容的安全类型
'utm_cco', // 内容的活动目标
'utm_cct', // 内容活动的策略
'utm_ccbt', // 内容的目标转化类型
'utm_cta', // 内容的目标用户群
'utm_tcn', // 团队创建人名称
'utm_tcv', // 团队创建的变量
'utm_tvcl', // 团队创建的虚拟id的长度
'utm_tcf', // 团队创建的格式
'utm_tcaw', // 团队创建的广告宽度
'utm_tcah' // 团队创建的广告高度
]; // 由于神策默认的渠道追踪参数是一个合并的结果，本次的字段会和上一次的字段进行合并（同名字段覆盖）作为本次的结果，数据不够准确干净，
// 咱们这里不用这个默认的方式，全部用自定义的字段，所以会加一个前缀

var utmPrefix = 'sa_'; // 神策分析

var getUTMParamNames = function getUTMParamNames() {
  return utmProps.filter(function (item) {
    // 跟默认同名的神策默认会收集，不用配置
    return defaultUTMProps.indexOf(item) === -1; // 不用includes 以提高本身的兼容性
  }).map(function (item) {
    return "".concat(utmPrefix).concat(item);
  });
};
/**
 * 获取自定义+用到的神策默认的字段名
 * @returns {string[]}
 */


export var getAllUTMParamNames = function getAllUTMParamNames() {
  var ourUTMParamNames = getUTMParamNames();
  ourUTMParamNames.push('utm_source', 'utm_medium');
  return ourUTMParamNames;
};
/**
 * 获取所有有效的UTM参数
 * @returns {{}}
 */

export var getAllUTMProps = function getAllUTMProps() {
  // UTM (Urchin Tracking Module) Google 渠道追踪的格式
  // eslint-disable-next-line no-restricted-globals
  var urlParams = getQueryParams(window.location);
  return getAllUTMParamNames().reduce(function (result, item) {
    var itemValue = urlParams[item] || '';
    var trimedItemValue = itemValue === null || itemValue === void 0 ? void 0 : itemValue.trim();

    if (trimedItemValue && trimedItemValue !== 'null' && trimedItemValue !== 'undefined') {
      result[item] = trimedItemValue;
    }

    return result;
  }, {});
};
/**
 * 获取需要上报的header信息，base64编码的JSON字符串
 * 只会获取url中存在的utm参数
 */

export var getUTMParamHeader = function getUTMParamHeader() {
  // eslint-disable-next-line no-restricted-globals
  var urlParams = getQueryParams(window.location);
  var paramsObj = getAllUTMParamNames().filter(function (item) {
    return item in urlParams;
  }).reduce(function (result, item) {
    result[item] = urlParams[item] || '';
    return result;
  }, {});
  return base64Encode(JSON.stringify(paramsObj));
};